
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { CustomFontFamily, FontFace } from "@/types/custom-fonts";
import FontFaces from "@/components/Settings/Preferences/CustomFonts/components/FontFaces.vue";
import Icon from "@/components/UI/Icon.vue";
import TextField from "@/components/Reusable/CustomInputs/TextInput.vue";

@Component({
  components: { Icon, FontFaces, TextField }
})
export default class FontFamily extends Vue {
  @Prop()
  value!: CustomFontFamily;

  @Prop()
  isOpen!: boolean;

  toggleFaces() {
    this.$emit("open", !this.isOpen);
  }

  deleteFontFamily() {
    this.$emit("delete");
  }

  fallbackStringHasBeenEdited = false;

  editFallbackString(newFallbackString: string | undefined) {
    this.fallbackStringHasBeenEdited = true;
    this.$emit("input", {
      ...this.value,
      fallbackString: newFallbackString
    });
  }

  editFontFamily(newFontFaces: FontFace[]) {
    this.$emit("input", {
      ...this.value,
      faces: newFontFaces
    });
  }

  editCssUrl(newCssUrl: string | undefined) {
    this.$emit("input", {
      ...this.value,
      cssUrl: newCssUrl
    });
  }
}
